import { addMonths } from 'date-fns/addMonths';
import { addYears } from 'date-fns/addYears';
import { endOfYear } from 'date-fns/endOfYear';
import { isSameDay } from 'date-fns/isSameDay';
import { isSameMonth } from 'date-fns/isSameMonth';
import { isSameYear } from 'date-fns/isSameYear';

import { EndType } from '../EndDateType';

const getEndDate = (value: EndType): Date | undefined => {
    const targetStartDate = new Date();
    switch (value) {
        case 'IN_6_MONHTS':
            return addMonths(targetStartDate, 6);
        case 'IN_12_MONTHS':
            return addYears(targetStartDate, 1);
        case 'IN_3_MONTHS':
            return addMonths(targetStartDate, 3);
        case 'TO_END_OF_YEAR':
            return endOfYear(targetStartDate);
        case 'NEVER':
        default:
            return undefined;
    }
};

const isSameDate = (date: Date, targetDate: Date) => {
    return isSameDay(date, targetDate) && isSameMonth(date, targetDate) && isSameYear(date, targetDate);
};

const getEndDateType = (date?: Date): EndType => {
    const startDate = new Date();
    if (!startDate || !date) {
        return 'NEVER';
    }

    if (isSameDate(date, addMonths(startDate, 6))) {
        return 'IN_6_MONHTS';
    }

    if (isSameDate(date, addYears(startDate, 1))) {
        return 'IN_12_MONTHS';
    }

    if (isSameDate(date, addMonths(startDate, 3))) {
        return 'IN_3_MONTHS';
    }

    if (isSameDate(date, endOfYear(startDate))) {
        return 'TO_END_OF_YEAR';
    }

    return 'CUSTOM';
};

export { getEndDateType, getEndDate };
